import { queryParamHookFactory } from '../modules/taboola-common-frontend-modules/query-params';
import { PERSISTENCE_TYPE } from '../modules/taboola-common-frontend-modules/storage';

const useReferrerInner = queryParamHookFactory('referrer', { persist: PERSISTENCE_TYPE.MEMORY });

export const useReferrer = () => {
    const [referrer] = useReferrerInner();
    return referrer;
};
